<template>
	<v-timeline dense clipped>
		<v-timeline-item
			small
			v-for="(status, index) in transactions"
			:key="index"
			:icon="status.active ? 'mdi-check' : null"
			:color="status.completed ? 'primary' : 'grey'"
		>
			<div>
				<h4>
					{{ status.title }}
				</h4>
				<div>
					{{ status.body }}
				</div>
			</div>
		</v-timeline-item>
	</v-timeline>
</template>

<script>
export default {
	props: ["transactions"],
};
</script>